"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../constants");

var utils_1 = require("../../../utils");

var Detail_1 = __importDefault(require("../../Card/Detail"));

var Image_1 = __importDefault(require("../../Card/Image"));

var Base_1 = __importDefault(require("../Base"));

require("./style.scss");

var useStyles_1 = __importDefault(require("./useStyles"));
/**
 * General Image layout Moment.
 */


var ImageMoment = function ImageMoment(props) {
  var caption = props.caption,
      direction = props.direction,
      label = props.label,
      url = props.url;
  var classes = (0, useStyles_1.default)();
  var containerClasses = (0, utils_1.classList)('moment-image-container', "moment-image-container-" + direction);
  /* eslint-disable react/jsx-props-no-spreading */

  return react_1.default.createElement(Base_1.default, __assign({}, props, {
    bodyClassName: classes.momentBody
  }), caption ? react_1.default.createElement("div", {
    className: containerClasses
  }, react_1.default.createElement("div", {
    className: "moment-image-container__image"
  }, react_1.default.createElement(Image_1.default, {
    alt: label,
    src: url
  })), react_1.default.createElement("div", {
    className: "moment-image-container__caption"
  }, react_1.default.createElement(Detail_1.default, null, caption))) : react_1.default.createElement(Grid_1.default, {
    className: classes.simpleGridContainer,
    container: true,
    justifyContent: "center"
  }, react_1.default.createElement(Grid_1.default, {
    className: classes.simpleGrid,
    item: true,
    md: 8,
    xs: 10
  }, react_1.default.createElement("img", {
    alt: label,
    className: classes.simple,
    src: url
  }))));
};

ImageMoment.propTypes = {
  /** Information to accompany the `Image`. */
  caption: prop_types_1.default.node,

  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),
  direction: prop_types_1.default.oneOf(['row', 'column']),

  /** Additional Props to pass to the `Image`. */
  // eslint-disable-next-line react/forbid-prop-types
  img: prop_types_1.default.object,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string,

  /** The source of the Image to render in the `Moment`'s body. */
  url: prop_types_1.default.string.isRequired
};
ImageMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  direction: 'row',
  label: '',
  layout: constants_1.MomentLayout.Image,
  type: constants_1.MomentType.Image
});
exports.default = ImageMoment;